import { handleError } from 'Helpers'

export default class PromoCode {
  constructor (element) {
    this.element = element
    this.copyButton = this.element.querySelector('.PromoCode__copy-button')
    this.copyMessage = this.element.querySelector('.PromoCode__message')
    this.codeCopy = this.element.querySelector('.PromoCode__copy-content')
    this.props = JSON.parse(this.element.dataset.props)

    this.init()
  }

  init () {
    if (this.copyButton) {
      this.copyButton.addEventListener('click', () => this.handleCopy())
    }
  }

  handleCopy () {
    navigator.clipboard.writeText(this.props.code)
      .then(() => {
        this.showCopiedMessage()
      })
      .catch((err) => {
        handleError(err)
      })
  }

  showCopiedMessage () {
    this.copyMessage.classList.remove('is-hidden')
    this.codeCopy.classList.add('is-hidden')
    this.copyButton.classList.add('Copied')

    setTimeout(() => {
      this.copyMessage.classList.add('is-hidden')
      this.codeCopy.classList.remove('is-hidden')
      this.copyButton.classList.remove('Copied')
    }, 5000)
  }
}
